import { PentestScanLight } from './pentest-scan-light';
import { PentestSeverityStatistics } from './pentest-severity-statistics';
import { CustomerPentestStatistics } from './customer-pentest-statistics';
import { CustomerLightData } from './customer-light.data';

export interface PartnerPentestStatistics {
  customer: CustomerLightData;
  statistics: CustomerPentestStatistics[];
}

export namespace PartnerPentestStatistics {
  export function mapFromApiValue(partnerPentestStatistics: any): PartnerPentestStatistics {
    return { ...partnerPentestStatistics };
  }
}
